import { Label } from 'components/atoms';
import { useFormikContext } from 'formik';
import React from 'react';
import { PiX } from 'react-icons/pi';
import {
  isActiveFilterValue,
  objectToArray,
} from 'utils/global/object.utils';
import './QueryFilterLabels.scss';

interface IQueryFilterLabelsProps {
  /** @deprecated Labels stay visible whether the filter menu is open or closed. */
  isFormOpen?: boolean;
  customLabel?: (data: { key: string; value: unknown }) => React.ReactNode;
}

const QueryFilterLabels = <T extends {}>({
  customLabel,
}: IQueryFilterLabelsProps) => {
  const { values, setValues } = useFormikContext<T>();

  const labels = objectToArray<T>(values).filter(data =>
    isActiveFilterValue(data.value)
  );

  const removeFilter = (key: string) => {
    setValues(prev => ({ ...prev, [key]: '' }));
  };

  const visibleLabels = labels
    .map(data => ({
      key: data.key,
      content: customLabel
        ? customLabel(data)
        : data.value
        ? `${data.value}`
        : '',
    }))
    .filter(
      label =>
        label.content !== undefined &&
        label.content !== null &&
        label.content !== ''
    );

  return !visibleLabels.length ? null : (
    <div className='query-filter-labels-wrapper'>
      <div className='query-filter-labels'>
        {visibleLabels.map(label => (
          <Label
            key={label.key}
            size='compact'
            className='query-filter-label'
            onClick={() => removeFilter(label.key)}>
            <PiX />
            <div className='label-text'>{label.content}</div>
          </Label>
        ))}
      </div>
    </div>
  );
};

export default QueryFilterLabels;
